import React, { useEffect, useRef, useState } from "react";
// import mic from "../assets/img/mic.png";
import mic from '../assets/img/mute-mic.svg';

import mutemic from '../assets/img/unmute-mic.svg';
import success from "../assets/img/success.png";
import smiley from "../assets/img/smiley.svg";
import { useDispatch, useSelector } from "react-redux";
import { getReportType } from "../redux/action";
import { json, useLocation, useNavigate, useParams } from "react-router";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import {
  CHECK_PATIENT_INTAKE_FROM_SUBMIT_API,
  PATIENT_FACE_IMAGE_MATCH_API,
  UPLOAD_CLICNICAL_INTAKE_DOC,
  UPLOAD_CLICNICAL_INTAKE_FILE,
  UPLOAD_CLICNICAL_INTAKE_RELEATIVES_DATA,
  UPLOAD_CLICNICAL_INTAKE_SUBMIT,
} from "../action/apiPath";
import { CallWithAuth } from "../action/apiActions";
import { toast, ToastContainer } from "react-toastify";
import Webcam from "react-webcam";
import moment from "moment";
import { showToast } from "../util/toastHelper";
import { base64ToBlob, base64ToFile } from "../util/base64ToFile";
import DigitalSignature from "../components/digitalSignature";
import { HIGHEST_ADD_RELATIVE } from "../util/constant";
import {
  createShortNameFileDoc,
  errorMessageCreate,
  getFileType,
} from "../util/custom";
import ReactSignatureCanvas from "react-signature-canvas";
import PatientHeader from "../components/patient/PatientHeader";
import { PatientFooter } from "../components/patient/PatientFooter";
import axios from "axios";
import { Tooltip as ReactTooltip } from "react-tooltip";

const fieldConfig = {
  referral_info: {
    label: "Referral Information:",
    // placeholder:
    //   "Who referred you, why, and when? (e.g., GP, self, diagnostic assessment)",
    placeholder: "Who referred you, why, and when?",
    key: "referral_info",
  },
  present_concern: {
    label: "Presenting Concerns:",
    // placeholder:
    //   "What is the main concern and any additional concerns? Duration? How is this impacting daily life?",
    placeholder: "What is the main concern and any additional concerns? Duration? How is this impacting daily life? current symptoms (e.g., poor sleep, low mood, anxiety)?",
    key: "present_concern",
  },
  medical_history: {
    label: "Medical and Psychiatric History:",
    // placeholder:
    //   "Current diagnoses (medical and mental health), medications, allergies? Past conditions or surgeries?",
    placeholder: "Current diagnoses (medical and mental health), medications, allergies? Past conditions or surgeries? Sleep patterns, appetite changes? Previous mental health diagnoses, treatments, inpatient stays, Any thoughts of self-harm or suicide? Any past suicide attempts?",
    key: "medical_history",
  },
  developmental_history: {
    label: "Developmental History:",
    // placeholder:
    //   "Pregnancy/birth complications? Early developmental milestones?",
    placeholder: "Pregnancy/birth complications? Early developmental milestones (e.g., first words, walking)? Social development, academic challenges, behavioural issues?",
    key: "developmental_history",
  },
  family_history: {
    label: "Family and Social History:",
    // placeholder:
    //   "Family mental and medical health history? Social support systems?",
    placeholder: "Family mental and medical health history? Who do you live with? Social support systems? Friendships and romantic relationships?",
    key: "family_history",
  },
  social_history: {
    label: "Educational/Occupational History:",
    // placeholder:
    //   "Current education/occupation? Learning difficulties or accommodations?",
    placeholder: "Current education/occupation? Any learning difficulties or accommodations? Job history and Education History and social relationships at work or school?",
    key: "social_history",
  },
  substance_use_history: {
    label: "Substance Use History:",
    // placeholder: "Any history of substance use or misuse?",
    placeholder: "Current/past use of substances? Frequency and impact on daily life?",
    key: "substance_use_history",
  },
  legal_history: {
    label: "Legal History:",
    // placeholder: "Any involvement with legal issues or convictions?",
    placeholder: "Any involvement with legal issues or convictions?",
    key: "legal_history",
  },
  cultural_context: {
    label: "Cultural and Social Context:",
    // placeholder: "Cultural background, religious beliefs, languages spoken?",
    placeholder: "Cultural background, religious beliefs, languages spoken, English language proficiency, and motor skills? Are there any cultural or religious factors affecting your assessment or treatment?",
    key: "cultural_context",
  },
  phychosocial_trauma: {
    label: "Experience of Significant Psychosocial Trauma:",
    // placeholder: "Details of any significant traumas and their impact?",
    placeholder: "Details of any significant traumas (e.g., car accident, physical or sexual assault, death of a loved one) and their impact? Any trauma-related symptoms?",
    key: "phychosocial_trauma",
  },
  additional_info: {
    label: "Additional Information:",
    // placeholder: "Any other relevant factors for your assessment?",
    placeholder: "Any other relevant factors you think are beneficial to consider in your diagnostic assessment?",
    key: "additional_info",
  },
};

const categoryStatic = [
  {
    id: "6f1bf9f2-3f09-465b-9884-d657261687f5",
    name: "Report Type A",
    created_at: "2024-11-05T06:49:58.156Z",
    updated_at: "2024-11-05T06:49:58.156Z",
  },
  {
    id: "91081fbf-b1d2-4505-83e5-de95385588fd",
    name: "Report Type B",
    created_at: "2024-11-05T06:53:29.366Z",
    updated_at: "2024-11-05T06:53:29.366Z",
  },
  {
    id: "0433fd14-090c-4724-bc51-fcf35923819a",
    name: "Report Type C",
    created_at: "2024-11-05T06:53:33.298Z",
    updated_at: "2024-11-05T06:53:33.298Z",
  },
];

export default function ClinicalIntakeFormNew() {
  const navigate = useNavigate();

  const selector = useSelector((state) => state.CLINICAL_INTAKE_REDUCER);
  const dispatch = useDispatch();
  const [activeField, setActiveField] = useState(null);
  const [successfullSubmission, setSuccessfullSubmission] = useState(false);
  const [successfullSubmissionMessage, setSuccessfullSubmissionMessage] =
    useState("");
  const [isSubmit, setIsSubmit] = useState(false);

  const [files, setFiles] = useState([
    { file: null, status: "not_uploaded", category: categoryStatic[0].id },
  ]);
  const [docs, setDocs] = useState([
    { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
  ]);

  const relativeTypeOptions = [
    { value: "relative", label: "Relative" },
    { value: "old_doctor", label: "Old Doctor" },
    // Add more options as needed
  ];

  const [dropdownOptions] = useState(categoryStatic);

  const location = useLocation();
  const [token, setToken] = useState(null);
  const [getFieldConfig, setFieldConfig] = useState(fieldConfig);
  const [dragging, setDragging] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(null);
  const webcamRef = useRef(null);
  // console.log("============>", files, docs)
  const [imageSrc, setImageSrc] = useState(null);
  const [face_image, setFaceImage] = useState(null);

  const [firstStep, setFirstStep] = useState(null);
  const [gerIsShare, setShareData] = useState(false);
  const [getDigitalSignature, setDigitalSignature] = useState(true);
  const [isChangeDigitalsignature, setIsChangeDigitalsignature] =
    useState(false);

  const [getRelativeConsentValue, setRelativeConsentValue] = useState(null);
  const [getConsentValue, setConsentValue] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const signaturePadRef = useRef(null);
  const [isAddedSignature, setIsAddedSignature] = useState(null);
  const [isDocsLoading, setIsDocsLoading] = useState(false);
  const [isSignatureLoading, setIsSignatureLoading] = useState(false);
  const [
    getDigitalSignatureFileBase64String,
    setDigitalSignatureFileBase64String,
  ] = useState(null);

  const [patientDetail, setPatientDetail] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [patient_face_image_consent, setPatientFaceImageConsent] =
    useState(false);
  const [hasFaceMatchConfirmation, setHasFaceMatchConfirmation] =
    useState(false);

  // const [relatives, setRelatives] = useState([
  //   { name: "", email: "", phone: "" },
  // ]);
  const [patientData, setPatientData] = useState({});
  const [relatives, setRelatives] = useState([]);
  const today = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD

  const [micBlocked, setMicBlocked] = useState(false);
  const lastTranscriptRef = useRef('');
  useEffect(() => {
    // console.log("17===>");

    // Use URLSearchParams to get the token from the URL
    // const params = new URLSearchParams(location.search);
    // const tokenParam = params.get("token");

    // if (tokenParam) {
    //   localStorage.setItem("patientToken", tokenParam);
    //   dispatch(getReportType());
    // }
    checkInakeFromSubmit();
  }, [location]);

  const [formData, setFormData] = useState({
    referral_info: "",
    present_concern: "",
    medical_history: "",
    developmental_history: "",
    family_history: "",
    social_history: "",
    substance_use_history: "",
    legal_history: "",
    cultural_context: "",
    phychosocial_trauma: "",
    additional_info: "",
  });

  const formDataLebel = {
    referral_info: "Referral Information",
    present_concern: "Presenting Concerns",
    medical_history: "Medical and Psychiatric History",
    developmental_history: "Developmental History",
    family_history: "Family and Social History",
    social_history: "Educational/Occupational History",
    substance_use_history: "Substance Use History",
    legal_history: "Legal History",
    cultural_context: "Cultural and Social Context",
    phychosocial_trauma: "Experience of Significant Psychosocial Trauma",
    additional_info: "Additional Information",
  };

  const [recognitionRef] = useState(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    return new SpeechRecognition();
  });

  useEffect(() => {
    // Get from localStorage if token matches
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get("token");
    const storedToken = localStorage.getItem("patientToken");
    const storedData = localStorage.getItem("formData");

    if (tokenParam === storedToken) {
      if (storedData) {
        try {
          let savedData = JSON.parse(storedData);
          setFormData(prev => ({
            ...prev,
            referral_info: savedData?.referral_info ?? "",
            present_concern: savedData?.present_concern ?? "",
            medical_history: savedData?.medical_history ?? "",
            developmental_history: savedData?.developmental_history ?? "",
            family_history: savedData?.family_history ?? "",
            social_history: savedData?.social_history ?? "",
            substance_use_history: savedData?.substance_use_history ?? "",
            legal_history: savedData?.legal_history ?? "",
            cultural_context: savedData?.cultural_context ?? "",
            phychosocial_trauma: savedData?.phychosocial_trauma ?? "",
            additional_info: savedData?.additional_info ?? "",
          }));
        } catch (error) {

        }

      }
      // const relativesData = localStorage.getItem("relatives")
      //   ? JSON.parse(localStorage.getItem("relatives"))
      //   : [];
      // if (Array.isArray(relativesData) && relativesData.length > 0) {
      //   setRelatives((relativesData));
      // }      
      let relativesData = [];

      try {
        const storedRelatives = localStorage.getItem("relatives");
        if (storedRelatives) {
          relativesData = JSON.parse(storedRelatives);
          setRelatives((relativesData));
        }
      } catch (error) {
        console.warn("Invalid JSON in localStorage for 'relatives':", error);
        setRelatives([]);
      }
    };
  }, []);
  useEffect(() => {
    localStorage.setItem('formData', JSON.stringify(formData));
  }, [formData]);
  useEffect(() => {
    localStorage.setItem('relatives', JSON.stringify(relatives));
  }, [relatives])
  const checkMicPermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Mic granted, you can stop the stream immediately
      stream.getTracks().forEach(track => track.stop());
      console.log('✅ Microphone access granted');
      return true;
    } catch (err) {
      if (err.name === 'NotAllowedError') {
        alert('Microphone access denied. Please enable it in your browser settings.');
      } else if (err.name === 'NotFoundError') {
        alert('No microphone found on this device.');
      } else {
        alert('Failed to access microphone.');
      }
      console.warn('Mic access error:', err);
      return false;
    }
    /*if (!navigator.permissions) {
      console.warn('Permissions API is not supported in this browser.');
      return false;
    }

    try {
      const status = await navigator.permissions.query({ name: 'microphone' });
       if (status.state === 'granted') {
        return true;
      } else if (status.state === 'denied') {
        alert('Microphone access is denied. Please enable it in your browser settings.');
        return false;

      } else if (status.state === 'prompt') {
        alert(' Microphone permission not yet granted — will be asked when needed.');
        return false;
      }

      // You can optionally listen for changes:
      status.onchange = () => {
        console.log('Microphone permission changed to:', status.state);
      };
    } catch (err) {
      console.warn('Permission check failed:', err);
      return false;
    }*/
  };
  // console.log("relatives====>", relatives);

  const checkInakeFromSubmit = async () => {
    // return;
    /*let response = await CallWithAuth(
      "GET",
      CHECK_PATIENT_INTAKE_FROM_SUBMIT_API
    );
    if (response?.res?.data?.statusCode === 200) {
      // console.log("response==>", response.res.data.data);
      setPatientFaceImageConsent(
        response?.res?.data?.data?.patient_face_image_consent
      );
      setHasFaceMatchConfirmation(
        !response?.res?.data?.data?.patient_face_image_consent
      );
      let message = errorMessageCreate(response?.res?.data?.message);
      showToast("success", message);
    } else {
      let message = errorMessageCreate(response?.res?.data?.message);
      // showToast("error", message);
      // setTimeout(() => {
      //   navigate("/");
      // }, 1000);
      setSuccessfullSubmission(true);
      setSuccessfullSubmissionMessage("Patient intake form already submitted");
    }
    setIsLoading(false);*/
    let params = new URLSearchParams(location.search);
    let tokenParam = params.get("token");
    // console.log("tokenParam===>", tokenParam);
    if (tokenParam) {
      localStorage.setItem("patientToken", tokenParam);
    }

    try {
      const header = {
        headers: {
          Authorization: `Bearer ${tokenParam}`,
        },
      };

      const response = await axios.get(
        CHECK_PATIENT_INTAKE_FROM_SUBMIT_API,
        header
      );

      if (response?.data?.statusCode === 200) {

        if (tokenParam) {
          localStorage.setItem("patientToken", tokenParam);
          dispatch(getReportType());
        }
        setPatientFaceImageConsent(
          response?.data?.data?.patient_face_image_consent
        );
        setHasFaceMatchConfirmation(
          !response?.data?.data?.patient_face_image_consent
        );
        setPatientData(response?.data?.data);
        let message = errorMessageCreate(response?.data?.message);
        showToast("success", message);
      } else {
        let message = '';
        if (response?.data?.statusCode === 401) {
          message = 'This link is expired';
        } else {
          message = errorMessageCreate(response?.data?.message)
        }
        setSuccessfullSubmission(true);
        setSuccessfullSubmissionMessage(message);
        localStorage.clear("formData");
        localStorage.clear("relatives");
      }
    } catch (error) {
      let message = '';
      if (error?.response?.data?.statusCode == 401) {
        message = 'This link is expired';
      } else {
        message = errorMessageCreate(
          error?.response?.data?.message || "An error occurred"
        );
      }
      // showToast("error", message);
      setSuccessfullSubmission(true);
      setSuccessfullSubmissionMessage(message);
      localStorage.clear("formData");
      localStorage.clear("relatives");
    }
    setIsLoading(false)
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validatePatientIntakeForm = async (formData) => {
    let errors = {};

    for (const key in formData) {
      if (formData[key].trim() === "") {
        errors[key] = `${formDataLebel[key]} is required`;

        // return errors[key];
        showToast("error", errors[key]);
        return false;
      }
    }
    return true;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("193===>", formData);
    // console.log("patient_face_image_consent===>", patient_face_image_consent);
    // console.log("hasFaceMatchConfirmation===>", hasFaceMatchConfirmation);

    if (patient_face_image_consent) {
      if (!hasFaceMatchConfirmation) {
        showToast("error", "Please provide a signature before saving.");
        return;
      }
    }
    let fromValid = await validatePatientIntakeForm(formData);
    // console.log("194===>", fromValid);

    if (!fromValid) {
      return;
    }
    // console.log("214");

    // console.log("175====>");
    if (isConfirmed) {
      if (!imageSrc) {
        showToast("error", "Please take a profile photo of your face.");
        return;
      }
    }
    if (!validateRelatives()) {
      return;
    }
    // if (getRelativeConsentValue === null) {
    //   showToast("error", "Please provide a consent before saving.");
    //   return;
    // }
    /* here check user added sign or not */

    if (getRelativeConsentValue === null) {
      showToast("error", "Please give consent");
      return 
    }

    if (getDigitalSignature) {
      if (!getDigitalSignatureFileBase64String) {
        showToast("error", "Please provide a signature before saving.");
        return;
      }
    }

    // if (!gerIsShare || gerIsShare) {

    // }
    // return false
    // console.log(isConfirmed);

    const allDocs = docs
      ?.filter((each) => each.status === "uploaded")
      ?.map((eachFile) => ({
        type: "doc",
        file: eachFile.doc,
        report_type_id: eachFile.category,
      }));
    const allFiles = files
      ?.filter((each) => each.status === "uploaded")
      ?.map((eachFile) => ({
        type: "audio",
        file: eachFile.file,
        report_type_id: eachFile.category,
      }));

    const alldata = {
      ...formData,
      files: [...allDocs, ...allFiles],
      relative_consent:
        relatives?.length == 0 ? false : getRelativeConsentValue, // Add the new key with its value
    };
    // console.log('377',relatives);

    // return ;
    setIsSubmit(true);
    try {
      const response = await handleSubmitResponse(alldata);

      if (
        response?.clientIntakeFromResponse?.res?.data?.statusCode === 200 &&
        gerIsShare
      ) {
        localStorage.clear("patientToken");
        localStorage.clear("formData");
        localStorage.clear("relatives");
        setSuccessfullSubmission(true);
        setSuccessfullSubmissionMessage("Thank you, your responses have been received.");
      } else if (
        response?.clientIntakeFromResponse?.res?.data?.statusCode === 200
      ) {
        setSuccessfullSubmission(true);
        setSuccessfullSubmissionMessage("Thank you, your responses have been received.");
        localStorage.clear("patientToken");
        localStorage.clear("formData");
        localStorage.clear("relatives");
      } else if (
        response?.clientIntakeFromResponse?.res?.data?.statusCode === 401
      ) {
        showToast(
          "error",
          response?.clientIntakeFromResponse?.res?.data?.message
        );
        setSuccessfullSubmission(true);
        setSuccessfullSubmissionMessage(
          response?.clientIntakeFromResponse?.res?.data?.message
        );
      } else {
        showToast(
          "error",
          response?.clientIntakeFromResponse?.res?.data?.message
        );
        localStorage.clear("formData");
        localStorage.clear("relatives");
        setSuccessfullSubmission(true);
        setSuccessfullSubmissionMessage(
          response?.clientIntakeFromResponse?.res?.data?.message
        );
      }
      setIsSubmit(false);
    } catch (error) {
      setIsSubmit(false);
      console.log(error);
    }

    // Add form submission logic here
  };

  // Initialize Speech Recognition
  /*let isRecognizing = false;   
  useEffect(() => {   
    
    const recognition = recognitionRef;
    if (!activeField || activeField == null || micBlocked  ) {       
      return;
    }
    
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = 'en-US';

    

    recognition.onresult = (event) => {
      let finalTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        const result = event.results[i];
        if (result.isFinal) {
          finalTranscript += result[0].transcript;
        }
      }

      // Trim and check against previous transcript
      const cleanTranscript = finalTranscript.trim();
      if (activeField && cleanTranscript && cleanTranscript !== lastTranscriptRef.current) {
        lastTranscriptRef.current = cleanTranscript; // Update ref
        setFormData((prevData) => ({
          ...prevData,
          [activeField]: (prevData[activeField] || '') + ' ' + cleanTranscript,
        }));
      }
    };
    recognition.onend = () => {
      
      if (activeField && isRecognizing) {        
        try {
          recognition.start();
          isRecognizing = true;
        } catch (e) {
          console.warn('Restart blocked:', e.message);
        }
      } else {
        isRecognizing = false;
        recognition.stop();
      }
    };

    recognition.onerror = (event) => {
      // console.error('Speech recognition error:', event.error);
      if (event.error === 'not-allowed' || event.error === 'service-not-allowed') {
        setMicBlocked(true);
        alert('Microphone access denied. Please allow microphone permission in your browser settings.');
        recognition.stop();
        isRecognizing= false;
      }
    };

    // Start recognition safely
    if (!isRecognizing && activeField) {
      try {
        recognition.start();
        isRecognizing = true;
      } catch (e) {        
        console.warn('Initial start blocked:', e.message);
      }
    }

    return () => {
      recognition.stop();
      isRecognizing = false;
    };
  }, [activeField , micBlocked]);*/
  // console.log);

  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } =
    useSpeechRecognition();
  const finalTranscriptRef = useRef('');

  if (!browserSupportsSpeechRecognition) {
    alert('Your browser does not support speech recognition.');
  }
  const previousTranscriptRef = useRef('');
  const debounceTimer = useRef(null);
  // 👂 Track only new spoken text
  useEffect(() => {
    if (!activeField) return;
    // Clear any pending update
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    // Set a delay before appending to formData
    debounceTimer.current = setTimeout(() => {
      const prev = previousTranscriptRef.current;
      const delta = transcript.slice(prev.length);
      if (delta.trim()) {
        setFormData((prevData) => ({
          ...prevData,
          [activeField]: (prevData[activeField] || '') + ' ' + delta.trim(),
        }));
        previousTranscriptRef.current = transcript;
      }
    }, 1000); // wait 1 second for the phrase to settle
  }, [transcript, activeField]);

  const handleVoiceInput = async (fieldName) => {
    let micPermission = await checkMicPermission();
    console.log('micPermission', micPermission);

    if (!micPermission) {
      return;
    }
    if (activeField === fieldName) {
      SpeechRecognition.stopListening();
      setActiveField(null);
      resetTranscript();
      previousTranscriptRef.current = '';
    } else {
      SpeechRecognition.stopListening();
      resetTranscript();
      previousTranscriptRef.current = '';
      setActiveField(fieldName);
      // Wait 200ms before starting again
      setTimeout(() => {
        SpeechRecognition.startListening({ continuous: true, language: 'en-US' });
      }, 200);
    }
  };



  const handleFileChange = (e, index) => {
    const newFiles = [...files];
    newFiles[index].file = e.target.files[0];
    newFiles[index].status = "not_uploaded";
    setFiles(newFiles);
  };

  const handleCategoryChange = (e, index) => {
    const newFiles = [...files];
    newFiles[index].category = e.target.value;
    setFiles(newFiles);
  };

  const handleUpload = async (index) => {
    const newFiles = [...files];
    const response = await handleUploadFile(newFiles[index].file);

    if (response?.res?.data?.statusCode === 200) {
      newFiles[index].status = "uploaded";
      newFiles[index].file = response?.res?.data?.data?.file_url;
    }
    setFiles(newFiles);
  };

  const addMoreFile = () => {
    setFiles([...files, { file: null, status: "not_uploaded", category: "" }]);
  };

  // Check if all files are uploaded
  const allFilesUploaded = files.every(
    (fileObj) => fileObj.status === "uploaded"
  );

  const handleDocsChange = (e, index) => {
    const newDocs = [...docs];
    // console.log("===========>", e.target.files);
    if (!e.target.files[0]) {
      return;
    }
    newDocs[index].system_file_name = e.target.files[0].name;
    newDocs[index].doc = e.target.files[0];
    newDocs[index].status = "not_uploaded";
    setDocs(newDocs);
  };

  const handleCategoryChangeForDocs = (e, index) => {
    const newDocs = [...docs];
    newDocs[index].category = e.target.value;
    setDocs(newDocs);
  };

  const handleUploadForDocs = async (index) => {
    const newDocs = [...docs];
    // console.log("newDocs", newDocs[index]);
    if (!newDocs[index].doc) {
      showToast("error", "Please select a file to upload");
      return;
    }
    setIsDocsLoading(true);
    const response = await handleUploadDocFile(newDocs[index].doc);

    if (response?.res?.data?.statusCode === 200) {
      console.log(newDocs[index]);

      newDocs[index].status = "uploaded";
      newDocs[index].doc = response?.res?.data?.data?.file_url;
      let message = errorMessageCreate(response?.res?.data?.message);
      showToast("success", message);
    } else {
      let message = errorMessageCreate(response?.res?.data?.message);
      showToast("error", message);
    }
    setIsDocsLoading(false);

    setDocs(newDocs);
  };

  const handleDeleteForDocs = (index) => {
    if (docs.length === 1) {
      setDocs([
        { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
      ]);
    } else {
      setDocs((prevDocs) => prevDocs.filter((_, i) => i !== index));
    }
  };

  const addMoreFileForDocs = () => {
    setDocs([
      ...docs,
      { doc: null, status: "not_uploaded", category: categoryStatic[0].id },
    ]);
  };

  const handleUploadDocFile = async (file) => {
    try {
      const formdata = new FormData();
      formdata.append("file", file);

      const body = formdata;

      return await CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_DOC, body, localStorage.getItem("patientToken"));
    } catch (err) { }
  };

  const handleUploadFile = async (file) => {
    try {
      const formdata = new FormData();
      formdata.append("file", file);

      const body = formdata;

      return await CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_FILE, body, localStorage.getItem("patientToken"));
    } catch (err) { }
  };

  const handleSubmitResponse = async (payload) => {
    try {
      // Prepare FormData for client intake submission
      const formData = new FormData();

      for (const key in payload) {
        if (key === "files") {
          // Handle the `files` key
          if (Array.isArray(payload[key]) && payload[key].length > 0) {
            formData.append(key, JSON.stringify(payload[key]));
          }
        } else {
          formData.append(key, payload[key]);
        }
      }

      /*if (isConfirmed) {
        if (imageSrc) {
          payload.face_image = face_image;
        }
      }*/

      if (getDigitalSignature) {
        payload.signature = getDigitalSignatureFileBase64String;
      }

      // if (gerIsShare) {
      // console.log("relatives==>427", relatives);

      payload.relatives = relatives;
      
      const params = new URLSearchParams(window.location.search);

      // const [clientIntakeFromResponse, additionalResponse] =
      const [clientIntakeFromResponse] = await Promise.all([
        CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_SUBMIT, payload, params.get("token")),
        // CallWithAuth("POST", UPLOAD_CLICNICAL_INTAKE_RELEATIVES_DATA, {
        //   relatives: relatives,
        // }),
      ]);
      // return { clientIntakeFromResponse, additionalResponse };
      return { clientIntakeFromResponse };
      // } else {
      //   const clientIntakeFromResponse = await CallWithAuth(
      //     "POST",
      //     UPLOAD_CLICNICAL_INTAKE_SUBMIT,
      //     payload
      //   );
      //   return { clientIntakeFromResponse };
      //   // You can handle the absence of the second API call here if needed
      // }

      // return await CallWithAuth(
      //   "POST",
      //   UPLOAD_CLICNICAL_INTAKE_SUBMIT,
      //   payload
      // );
    } catch (err) { }
  };
  //for speaker
  const handleVolumeUpDown = (value, key) => {
    // Create a copy of the fieldConfig state
    const updatedFieldConfig = { ...getFieldConfig };
    // Iterate over all keys in the updatedFieldConfig object
    Object.keys(updatedFieldConfig).forEach((k) => {
      // Set `isVolume` to false for all keys
      updatedFieldConfig[k].isVolume = false;
    });
    // Update the `isVolume` property for the specific key
    updatedFieldConfig[key] = {
      ...updatedFieldConfig[key],
      isVolume: true,
    };
    const speakWithVoice = () => {
      const utterance = new SpeechSynthesisUtterance(value);
      const voices = window.speechSynthesis.getVoices();

      const femaleVoice = voices.find(voice =>
        voice.name.toLowerCase().includes('zira') ||
        voice.name.toLowerCase().includes('google us english') ||
        voice.name.toLowerCase().includes('female')
      );

      if (femaleVoice) {
        utterance.voice = femaleVoice;
      }

      utterance.lang = 'en-US';
      utterance.rate = 1;
      utterance.pitch = 1;

      speechSynthesis.speak(utterance);
    };

    if ('speechSynthesis' in window) {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length > 0) {
        // Voices are already loaded
        speakWithVoice();
      } else {
        // Wait for voices to load and then speak
        window.speechSynthesis.onvoiceschanged = () => {
          speakWithVoice();
        };
      }
    } else {
      alert("Speech Synthesis not supported in this browser.");
    }
    // Update the state with the modified fieldConfig
    setFieldConfig(updatedFieldConfig);
  };
  const handleVolumeUpDownReset = (value, key) => {
    // getFieldConfig[key].isVolume = false;
    // setFieldConfig(getFieldConfig);
    const updatedFieldConfig = { ...getFieldConfig };
    // Iterate over all keys in the updatedFieldConfig object
    Object.keys(updatedFieldConfig).forEach((k) => {
      // Set `isVolume` to false for all keys
      updatedFieldConfig[k].isVolume = false;
    });
    updatedFieldConfig[key] = {
      ...updatedFieldConfig[key],
      isVolume: false,
    };
    // if (window.speechSynthesis.speaking) {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel(); // Stop the current speech
    }
    // Update the state with the modified fieldConfig
    setFieldConfig(updatedFieldConfig);
  };
  // console.log("311", getFieldConfig);

  // Handle file drop
  const handleDrop = (e, index) => {
    e.preventDefault();
    setDragging(false);

    // Get the dropped files
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      // Simulate onChange for the input file
      const event = {
        target: {
          name: `doc-${index}`,
          files,
        },
      };
      handleDocsChange(event, index);
    }
  };

  // Handle drag over to allow dropping
  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  // Handle drag leave
  const handleDragLeave = () => {
    setDragging(false);
  };

  // Check if all files are uploaded
  const allFilesUploadedForDocs = docs.every(
    (fileObj) => fileObj.status === "uploaded"
  );

  const handleConfirmationChange = (value) => {
    setIsConfirmed(value);
    setFirstStep(true);
    /*if (!value) {
      setFirstStep(true);
    }*/
  };
  const capture = async (e) => {
    e.preventDefault();
    const image = webcamRef.current?.getScreenshot();
    if (image) {
      // setImageSrc(image);
      // setFaceImage(image);
      // setFirstStep(true);
      setIsLoading(true);
      let fileName = "face_image.jpeg";
      let face_image = await base64ToFile(image, fileName, "image/jpeg");
      // console.log("face_image===>", image);
      // return;

      const response = await handleUploadDocFile(face_image);
      // return;
      let message = errorMessageCreate(response?.res?.data?.message);
      if (response?.res?.data?.statusCode === 200) {
        // console.log("response==>", response.res.data.data.file_url);
        setFaceImage(response.res.data.data.file_url);
        const responseFaceImg = await CallWithAuth(
          "POST",
          PATIENT_FACE_IMAGE_MATCH_API,
          {
            face_image: response.res.data.data.file_url,
            // face_image: "https://mentalhealthaibucket.s3.amazonaws.com/1747235601829_face_image.jpg",
            // face_image:
            //   "https://mentalhealthaibucket.s3.amazonaws.com/1738758257330_demo-pic35.jpg",
          },
          localStorage.getItem("patientToken")
        );
        let message = errorMessageCreate(responseFaceImg?.res?.data?.message);
        if (responseFaceImg?.res?.data?.statusCode === 200) {
          setImageSrc(image);
          setHasFaceMatchConfirmation(true);
          showToast("success", message);
        } else {
          showToast("error", message);
        }
        // setImageSrc(image);
        // setFirstStep(true);
        // showToast("success", "Face image uploaded successfully");
      } else {
        showToast("error", message);
      }
      setIsLoading(false);
    }
  };
  const handleshareDataChange = (shareData) => {
    setShareData(shareData);
  };
  // const handleInputChange = (index, field, value) => {
  //   const updatedRelatives = [...relatives];
  //   updatedRelatives[index][field] = value;
  //   setRelatives(updatedRelatives);
  // };
  const handleInputChange = (index, field, value) => {
    const updatedRelatives = [...relatives];
    updatedRelatives[index][field] = value;

    // Check if the field is email or phone number and if it's a duplicate
    if (field === "email" || field === "phone") {
      const duplicate = updatedRelatives.some(
        (relative, i) => relative[field] === value && i !== index // Avoid comparing with the same relative
      );

      if (duplicate) {
        // alert(`${field.charAt(0).toUpperCase() + field.slice(1)} is already in use.`);
        showToast(
          "error",
          `${field.charAt(0).toUpperCase() + field.slice(1)
          } is already in use please change.`
        );
        return;
      }
    }

    setRelatives(updatedRelatives);
  };
  // console.log("relatives", relatives);

  // const addRelative = () => {
  //   setRelatives([...relatives, { full_name: "", email: "", phone: "" }]);
  // };

  const validateRelatives = () => {
    for (const [index, relative] of relatives.entries()) {
      console.log("relative", relative);

      if (!relative.name) {
        showToast("error", `Name is required for relative ${index + 1}.`);
        return false;
      }

      if (relative.email.trim() == "") {
        showToast("error", `Email is required for relative ${index + 1}.`);
        return false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(relative.email)) {
        showToast("error", `Invalid email format for relative ${index + 1}.`);
        return false;
      }

      if (!relative.phone) {
        showToast(
          "error",
          `Phone number is required for relative ${index + 1}.`
        );
        return false;
      } else if (!/^[0-9]{10}$/.test(relative.phone)) {
        showToast(
          "error",
          `Please enter a valid 10-digit phone number for relative ${index + 1
          }.`
        );
        return false;
      }
    }
    return true; // All validations passed
  };

  const addRelative = () => {
    // Validate existing relatives' details
    if (!validateRelatives()) {
      return;
    }

    if (relatives.length >= HIGHEST_ADD_RELATIVE) {
      showToast("error", "You can add a maximum of 6 relatives.");
      return;
    }
    // Add a new relative if validation passes
    setRelatives([
      ...relatives,
      { name: "", email: "", phone: "", relative_type: "relative" },
    ]);
  };
  const removeRelative = (index) => {
    const updatedRelatives = relatives.filter((_, i) => i !== index);
    setRelatives(updatedRelatives);
  };

  /**
   * Handles changes to the digital signature component.
   *
   * @param {object} e - The event object representing the change event.
   */
  const handleChangeDigitalsignature = (e) => {
    // Update the digital signature state with the new value
    setDigitalSignature(e);
  };
  /**
   * Handles saving the digital signature to the component state.
   *
   * @param {string} signatureData - The base64 encoded string representation of the digital signature.
   */
  const handleSaveSignature = async (signatureData) => {
    console.log("signatureData===>", signatureData);

    // console.log('signatureData===>',signatureData);

    // Update the digital signature state with the new value
    // setDigitalSignatureFileBase64String(signatureData);
    let fileName = "digital_signature.jpeg";
    let signature_image = await base64ToFile(
      signatureData,
      fileName,
      "image/jpeg"
    );
    setIsLoading(true);
    const response = await handleUploadDocFile(signature_image);
    let message = errorMessageCreate(response?.res?.data?.message);
    if (response?.res?.data?.statusCode === 200) {
      // console.log("response==>", response.res.data.data.file_url);
      setDigitalSignatureFileBase64String(response.res.data.data.file_url);
      showToast("success", "Digital signature uploaded successfully");
    } else {
      showToast("error", message);
    }
    setIsLoading(false);
  };

  const handleRelativeConsentChange = (event) => {
    // const selectedValue = event.target.value === "true"; // Convert string to boolean
    // console.log(selectedValue);

    setRelativeConsentValue(event); // Update state
  };
  // console.log('gerIsShare====>',gerIsShare);
  const handleSignatureChange = () => {
    // Check if the user has drawn a signature
    if (!signaturePadRef.current.isEmpty()) {
      // setIsAddedSignature(true);
      setIsChangeDigitalsignature(true);
    }
  };
  const clearSignature = (e) => {
    e.preventDefault();
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
      setDigitalSignatureFileBase64String(null);
      // setIsAddedSignature(false);
      setIsChangeDigitalsignature(false);
    }
  };
  const saveSignature = async (e) => {
    e.preventDefault();
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      const signatureDataURL = signaturePadRef.current.toDataURL();
      // console.log("Saved Signature:", signatureDataURL);
      // Update the digital signature state with the new value
      // setDigitalSignatureFileBase64String(signatureData);
      let fileName = "digital_signature.jpeg";
      let signature_image = await base64ToFile(
        signatureDataURL,
        fileName,
        "image/jpeg"
      );
      setIsSignatureLoading(true);

      const response = await handleUploadDocFile(signature_image);
      let message = errorMessageCreate(response?.res?.data?.message);

      if (response?.res?.data?.statusCode === 200) {
        setDigitalSignatureFileBase64String(response.res.data.data.file_url);
        showToast("success", "Digital signature uploaded successfully");
      } else {
        showToast("error", message);
      }
      setIsSignatureLoading(false);
    } else {
      alert("Please provide a signature before saving.");
    }
  };
  // console.log("isDocsLoading===>", isDocsLoading);

  return (
    <>
      <PatientHeader />
      <div className="container my-5 pt-5">
        {isLoading && (
          // <><h1 className="text-center">Report loading...</h1></>
          <>
            <div className="full-page-loader">
              <div className="loader"></div>
            </div>
          </>
        )}
        <section className="clinical-intake-form">
          {successfullSubmission ? (
            <>
              {/* <img src={success} alt="success" className="successmsg" /> */}

              <div className="thankyou-box">
                <img src={smiley} alt="" />
                <h2>{successfullSubmissionMessage}</h2>
              </div>
              {/* <button className="solid_cta cta_primary mx-auto mt-5 d-flex justify-content-center">Back</button> */}
            </>
          ) : (
            <div className="container">
              <h3>PsychScribe: Clinical Intake Form </h3>

              <div className="form-cntn-box">
                <h5>Important Preface </h5>
                <p>
                  We understand that your clinician has obtained your consent
                  for your healthcare data to be collected by PsychScribe for
                  the purpose of diagnostic clinical reasoning and report
                  writing assistance. All the information you share in this form
                  will be treated with strict confidentiality, de-identified to
                  protect your privacy, and handled in accordance with the 1988
                  Privacy Act, the Australian Privacy Principles (APP), and
                  HIPAA guidelines.
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                {patient_face_image_consent && (
                  <>
                    <div>
                      <p style={{ fontWeight: "bold" }}>
                        Consent is required to upload your photo for face
                        verification. Please provide your consent to proceed.
                      </p>
                      <label>
                        <input
                          type="radio"
                          name="confirmation"
                          value="yes"
                          onChange={() => handleConfirmationChange(true)}
                        />{" "}
                        Yes
                      </label>
                    </div>
                  </>
                )}

                {isConfirmed && (
                  // <Webcam
                  //   audio={false}
                  //   ref={webcamRef}
                  //   screenshotFormat="image/jpeg"
                  //   width={640}
                  //   height={480}
                  // />
                  <>
                    <div>
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        width={640}
                        height={480}
                        onUserMediaError={() =>
                          alert(
                            "Camera access denied. Please check your browser settings."
                          )
                        }
                        videoConstraints={{
                          width: 1280,
                          height: 720,
                          facingMode: "user",
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={capture}
                        style={{ display: "block" }}
                      >
                        Capture Photo
                      </button>
                      {imageSrc && (
                        <div>
                          <h3>Captured Image:</h3>
                          <img src={imageSrc} alt="Captured" />
                        </div>
                      )}
                    </div>
                  </>
                )}

                {/* {firstStep && ( */}
                {hasFaceMatchConfirmation && (
                  <>
                    <div className="row">
                      {/* {Object.keys(formData).map((key) => ( */}
                      {Object.keys(getFieldConfig).map((key) => (
                        <div className="col-md-6">
                          <div className="form-group" key={key}>
                            <div className="d-flex add-form-group-align">
                              <label className="ml-2">
                                {" "}
                                {fieldConfig[key].label}
                                <sup className="text-danger">*</sup>
                              </label>
                              {getFieldConfig[key]?.isVolume === true ? (
                                <i
                                  className="fa fa-volume-mute "
                                  onClick={() =>
                                    handleVolumeUpDownReset(
                                      `${fieldConfig[key].label}`,
                                      key
                                    )
                                  }
                                />
                              ) : (
                                <i
                                  className="fa fa-volume-up"
                                  onClick={() =>
                                    handleVolumeUpDown(
                                      `${fieldConfig[key].label}`,
                                      key
                                    )
                                  }
                                />
                              )}
                            </div>

                            <textarea
                              className="form-control pr"
                              placeholder={fieldConfig[key].placeholder}
                              name={key}
                              value={formData[key]}
                              onChange={handleChange}
                            />
                            <button
                              type="button"
                              onClick={() => handleVoiceInput(key)}
                              className="microphone"
                            >
                              {/* {activeField === key ? "Stop" : "Voice to Text"} */}
                              {activeField == key ? (
                                <img
                                  src={mutemic}
                                  alt="microphone"
                                  width="36"
                                  height="36"
                                />
                              ) : (
                                <img
                                  src={mic}
                                  alt="microphone"
                                  width="24"
                                  height="24"
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="form-group col-info">
                      <label for="Collateral Information">
                        Collateral Information
                      </label>
                      <button
                        data-tooltip-id="collateral-Information-tooltip"
                        type="button"
                        className="details-tooltips"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-className="custom-tooltip"
                        data-bs-title="Please provide any collateral documents (e.g., school reports, medical records, psychological or allied health assessments) and upload relevant documentation below to assist with the assessment and report writing process)."
                      >
                        <i className="fa-solid fa-circle-info"></i>
                      </button>
                      <ReactTooltip
                        id="collateral-Information-tooltip"
                        place="bottom"
                        variant="info"
                        className="custom-tooltip"
                        content="Please provide any collateral documents (e.g., school reports, medical records, psychological or allied health assessments) and upload relevant documentation below to assist with the assessment and report writing process)."
                      />
                    </div>
                    <div className="d-flex">
                      {/* **********************DOCUMENT UPLOAD****************** */}
                      <div className="w-50 pr-4 customclass">
                        {docs.map((fileObj, index) => (
                          <div className="w-100">
                            <div key={index} className="form-group ff">
                              {fileObj.status === "uploaded" ? (
                                // <span>
                                //   <i
                                //     className="fa-solid fa-file-alt"
                                //     style={{ marginRight: "8px" }}
                                //   ></i>
                                //   Document File uploaded
                                // </span>
                                <div className="uploaded-file-info">
                                  <p>Document File uploaded</p>
                                  <p>
                                    <span
                                      className="file-name"
                                      data-tooltip-id={`collateral-Information-tooltip-${fileObj?.index}`}
                                      data-tooltip-content={fileObj.system_file_name}
                                    >
                                      {createShortNameFileDoc(fileObj.system_file_name)}
                                    </span>
                                    <ReactTooltip
                                      id={`collateral-Information-tooltip-${fileObj?.index}`}
                                      place="bottom"
                                      variant="info"
                                      className="custom-tooltip"
                                      content={fileObj.system_file_name}
                                    />
                                    <span className="file-type">
                                      ({getFileType(fileObj.doc)})
                                    </span>
                                  </p>
                                </div>
                              ) : (
                                <div
                                  className="upload-container"
                                  onDrop={(e) => handleDrop(e, index)}
                                  onDragOver={handleDragOver}
                                  onDragLeave={handleDragLeave}
                                >
                                  <input
                                    type="file"
                                    id={`doc-input-${index}`}
                                    name={`doc-${index}`}
                                    accept=".doc, .docx, .pdf , .png, .jpg, .jpeg"
                                    onChange={(e) => handleDocsChange(e, index)}
                                  />
                                  <span onClick={() => document.getElementById(`doc-input-${index}`).click()} className="upload-icon">
                                    <i className="fa-solid fa-arrow-up"></i>
                                  </span>

                                  <label
                                    htmlFor={`doc-input-${index}`}
                                    className="file-label"
                                  >
                                    Upload
                                  </label>
                                  {fileObj.doc ? (
                                    <>
                                      <p id="file-name" className="browse-file">
                                        Document Selected Please Upload doc.
                                      </p>
                                      {/*  */}
                                    </>
                                  ) : (
                                    <>
                                      <br />
                                      <br />
                                      <p id="file-name" className="browse-file">
                                        <span>Browse to upload the file</span>{" "}
                                        <br />
                                        <div>
                                          Supported file types: .doc, .docx,
                                          .pdf, .png, .jpg, .jpeg
                                        </div>
                                      </p>
                                      {/* <p>Supported file types: .doc, .docx, .pdf, .png, .jpg, .jpeg</p> */}
                                    </>
                                  )}
                                </div>
                              )}

                              <div className="otherbuttons d-flex">
                                {/* <select
                                  value={fileObj.category}
                                  onChange={(e) =>
                                    handleCategoryChangeForDocs(e, index)
                                  }
                                  className="file-category-dropdown form-control"
                                >
                                  {dropdownOptions.map((option, i) => (
                                    <option key={i} value={option.id}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select> */}
                                <div className="d-flex">
                                  <button
                                    type="button"
                                    onClick={() => handleUploadForDocs(index)}
                                    // disabled={!fileObj.doc || !fileObj.category || fileObj.status === 'uploaded'}
                                    // style={{
                                    //   color: (fileObj.doc || fileObj.category || fileObj.status !== 'uploaded') && "white",
                                    //   backgroundColor: (fileObj.doc || fileObj.category || fileObj.status !== 'uploaded') && "#4d9d30",
                                    // }}
                                    disabled={
                                      isDocsLoading &&
                                        fileObj.status !== "uploaded"
                                        ? isDocsLoading
                                        : false
                                    }
                                    className="upload-button form-control"
                                  >
                                    {/* {fileObj.status === "uploaded"
                                  ? "Uploaded"
                                  : "Upload"} */}
                                    {isDocsLoading &&
                                      fileObj.status !== "uploaded" ? (
                                      <>
                                        Upload
                                        <span className="button-loader-cls"></span>
                                      </>
                                    ) : fileObj.status === "uploaded" ? (
                                      "Uploaded"
                                    ) : (
                                      "Upload"
                                    )}
                                  </button>
                                  {fileObj.status === "uploaded" && (
                                    <button
                                      type="button"
                                      onClick={() => handleDeleteForDocs(index)}
                                      className="delete-button form-control"
                                      style={{ marginLeft: "10px" }}
                                    >
                                      Remove
                                    </button>
                                  )}
                                </div>

                                {allFilesUploadedForDocs &&
                                  index === docs.length - 1 && (
                                    <button
                                      type="button"
                                      onClick={addMoreFileForDocs}
                                      className="add-more-button form-control"
                                    >
                                      Add More Files
                                    </button>
                                  )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* ********************************FILE UPLOAD******************** */}
                      {/* <div className="w-50 pl-4 customclass">
                    {files.map((fileObj, index) => (
                      <div key={index} className="form-group">
                        {fileObj.status === "uploaded" ? (
                          <span>
                            <i
                              className="fa-solid fa-music"
                              style={{ marginRight: "8px" }}
                            ></i>
                            Audio file uploaded
                          </span>
                        ) : (
                          <div className="upload-container">
                            <span className="upload-icon">
                              <i className="fa-solid fa-arrow-up"></i>
                            </span>
                            <input
                              type="file"
                              id={`file-input-${index}`}
                              name={`file-${index}`}
                              accept=".mp3, .wav, .m4a"
                              onChange={(e) => handleFileChange(e, index)}
                            />
                            <label
                              htmlFor={`file-input-${index}`}
                              className="file-label"
                            >
                              Upload
                            </label>
                            {fileObj.file ?
                              <p id="file-name" className="browse-file">
                                Document Selected Please select Category and Upload doc.
                              </p>
                              :
                              <p id="file-name" className="browse-file">
                                Browse <span>to upload the file</span>
                              </p>
                            }
                          </div>
                        )}

                        <div className="otherbuttons d-flex">
                          
                          <select
                            value={fileObj.category}
                            onChange={(e) => handleCategoryChange(e, index)}
                            className="file-category-dropdown form-control"
                          >
                            <option value="">Select category</option>
                            {dropdownOptions.map((option, i) => (
                              <option key={i} value={option.id}>
                                {option.name}
                              </option>
                            ))}
                          </select>

                          
                          <button
                            type="button"
                            onClick={() => handleUpload(index)}
                            // disabled={!fileObj.file || !fileObj.category || fileObj.status === 'uploaded'}
                            // style={{
                            //   color: (fileObj.file || fileObj.category || fileObj.status !== 'uploaded') && "white",
                            //   backgroundColor: (fileObj.file || fileObj.category || fileObj.status !== 'uploaded') && "#4d9d30",
                            // }}
                            className="upload-button form-control"
                          >
                            {fileObj.status === "uploaded" ? "Uploaded" : "Upload"}
                          </button>

                      
                          {allFilesUploaded && index === files.length - 1 && (
                            <button
                              type="button"
                              onClick={addMoreFile}
                              className="add-more-button form-control"
                            >
                              Add More Files
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div> */}
                    </div>

                    {/* <div style={{ marginTop: "20px" }}>
                    <p style={{ fontWeight: "bold" }}>
                      Are you sure you want to provide the clinician with
                      permission to share this information with their relatives,
                      friends, or other doctors?
                    </p>
                    <label>
                      <input
                        type="radio"
                        name="shareData"
                        value="yes"
                        onChange={() => handleshareDataChange(true)}
                      />{" "}
                      Yes
                    </label>
                    <label style={{ marginLeft: "10px" }}>
                      <input
                        type="radio"
                        name="shareData"
                        value="no"
                        onChange={() => handleshareDataChange(false)}
                      />{" "}
                      No
                    </label>
                  </div> */}
                    {/* {!gerIsShare || gerIsShare || (
                    <> */}
                    {/* Add Button on Top */}
                    <div style={{ lineHeight: 1.6, marginTop: "20px" }}>
                      <strong>Consent to Obtain and/or Share Information</strong>
                      <p>
                        By signing below, I confirm that I provide informed consent for my treating clinician
                        (psychologist/psychiatrist) to <strong>obtain and/or share information</strong> with the
                        health professional(s), informal support person(s) (e.g. family member, support worker), or
                        other nominated individual(s) listed in this form for the purposes of assessment, diagnosis,
                        and treatment planning.
                      </p>

                      <p>
                        This consent is provided <u>in accordance with</u> the{' '}
                        <strong>Privacy Act 1988 (Cth)</strong> and the{' '}
                        <strong>Health Records and Information Privacy legislation applicable within Australia</strong>,
                        and I understand that my personal information will be managed in line with relevant
                        confidentiality and privacy obligations.
                      </p>


                      {/* <div className="mcl" style={{ marginTop: "20px" }}> */}

                      <label>I understand that this consent remains valid unless withdrawn in writing.
                      </label>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="obtainOnly"
                          checked={getRelativeConsentValue === false}
                          onChange={() => setRelativeConsentValue(false)}
                        />
                        <strong className="form-check-label" htmlFor="obtainOnly">
                          {/* Obtain-only from 3rd party */}
                          I consent to obtaining only information
                        </strong>
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="shareAndObtain"
                          checked={getRelativeConsentValue === true}
                          onChange={() => setRelativeConsentValue(true)}
                        />
                        <strong className="form-check-label" htmlFor="shareAndObtain">
                          {/* Share-and-obtain with and from 3rd party */}
                          I consent to obtaining and sharing information
                        </strong>
                      </div>
                    </div>
                    <div
                      className="foralign mt-3"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <button
                        type="button"
                        onClick={addRelative}
                        className="add_button btn btn-primary"
                        disabled={relatives.length >= HIGHEST_ADD_RELATIVE}
                      >
                        Add More Contacts
                      </button>
                      <p
                        style={{
                          marginLeft: "10px",
                          fontWeight: "bold",
                          marginBottom: "0px",
                        }}
                      >
                        You can add upto {HIGHEST_ADD_RELATIVE} Contacts
                      </p>
                    </div>

                    {relatives.map((relative, index) => (
                      <section
                        key={index}
                        className="patient_form_block relatives_form_block"
                      >
                        <div
                          style={{ color: "green" }}
                          className="added-relatives-count"
                        >
                          {/* <p>
                            {index + 1}. information with their relatives,
                            friends, or other health professionals?
                          </p> */}
                        </div>
                        <div className="site_container relatives_form_site_container">
                          <div className="patient_form relatives_form">
                            <div className="field_block">
                              <label htmlFor={`full_name_${index}`}>
                                Full name*
                              </label>
                              <input
                                type="text"
                                name="name"
                                id={`full_name_${index}`}
                                className="text_field"
                                placeholder="Enter Full Name"
                                value={relative.name}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "name",
                                    e.target.value
                                  )
                                }
                              />
                            </div>

                            <div className="field_block ">
                              <label htmlFor={`email_${index}`}>Email*</label>
                              <input
                                placeholder="Enter your email."
                                type="text"
                                name="email"
                                id={`email_${index}`}
                                className="text_field"
                                value={relative.email}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "email",
                                    e.target.value
                                  )
                                }
                              />
                            </div>

                            <div className="field_block  ">
                              <label htmlFor={`phone_${index}`}>
                                Phone Number*
                              </label>
                              <input
                                placeholder="Enter phone number."
                                type="text"
                                name="phone"
                                id={`phone_${index}`}
                                className="text_field"
                                value={relative.phone}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "phone",
                                    e.target.value
                                  )
                                }
                              />
                            </div>

                            {/* New relative_type dropdown */}
                            <div className="field_block">
                              <label htmlFor={`relative_type_${index}`}>
                                Referral Type*
                              </label>
                              <select
                                name="relative_type"
                                id={`relative_type_${index}`}
                                className="text_field"
                                value={relative.relative_type}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "relative_type",
                                    e.target.value
                                  )
                                }
                              >
                                {relativeTypeOptions.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.value == 'relative' ? 'Informal' : 'Professional'}
                                  </option>
                                ))}
                              </select>

                              {/* {index > 0 && ( */}

                              {/* )} */}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => removeRelative(index)}
                            className="remove_button clear-btn"
                            style={{ marginTop: "10px" }}
                          >
                            Remove Contact
                          </button>
                        </div>
                      </section>
                    ))}
                    {/* </>
                  )} */}
                    {/* <div className="mcl" style={{ marginTop: "20px" }}>
                      <label>Consent to Obtain and/or Share Information</label>
                      <select
                        className="file-category-dropdown form-control"
                        onChange={handleRelativeConsentChange}
                        value={getRelativeConsentValue}
                        disabled={relatives.length === 0}
                      >
                        <option value={false}>
                          Obtain-only from 3rd party
                        </option>
                        <option value={true}>
                          Share-and-obtain with and from 3rd party
                        </option>
                      </select>
                    </div> */}

                    <div className="row">
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group">
                          <div className="d-flex add-form-group-align">
                            <label className="ml-2">Name</label>
                          </div>

                          <input
                            className="form-control text_field"
                            type="text"
                            readOnly
                            value={patientData?.full_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group">
                          <div className="d-flex add-form-group-align">
                            <label className="ml-2">Date</label>
                          </div>

                          <input
                            className="form-control text_field"
                            type="date"
                            readOnly
                            value={today}
                          />

                        </div>
                      </div>
                    </div>


                    <div style={{ marginTop: "20px" }}>
                      <p style={{ fontWeight: "bold" }}>
                        {/* Are you sure you want to provide a digital signature? */}
                        {/* Are you sure you want to provide your digital signature? */}
                        Please provide your digital signature
                      </p>
                      {/* <label>
                        <input
                          type="radio"
                          name="shareData"
                          value="yes"
                          onChange={() => handleChangeDigitalsignature(true)}
                        />{" "}
                        Yes
                      </label>
                      <label style={{ marginLeft: "10px" }}>
                        <input
                          type="radio"
                          name="shareData"
                          value="no"
                          onChange={() => handleChangeDigitalsignature(false)}
                        />{" "}
                        No
                      </label> */}
                    </div>

                    {getDigitalSignature && (
                      <>
                        {/* <DigitalSignature
                        errorMessage="Please provide a signature before saving."
                        onSaveSignature={handleSaveSignature}
                        onClearCanvas={handleCanvasClear}
                      /> */}
                        <div className="signature-container">
                          <h3>Digital Signature</h3>
                          <ReactSignatureCanvas
                            ref={signaturePadRef}
                            penColor="black"
                            canvasProps={{
                              width: 500,
                              height: 200,
                              className: "signature-canvas",
                            }}
                            onEnd={handleSignatureChange}
                          />
                          <button
                            className="clear-btn"
                            onClick={clearSignature}
                          >
                            {" "}
                            Clear signature
                          </button>
                          {isChangeDigitalsignature && (
                            <button
                              disabled={isSignatureLoading}
                              className="save-btn"
                              onClick={saveSignature}
                            >
                              Save signature{" "}
                              {isSignatureLoading && (
                                <>
                                  <span className="button-loader-cls"></span>
                                </>
                              )}
                            </button>
                          )}
                        </div>
                      </>
                    )}





                    {/* </div> */}




                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmit}
                      >
                        {/* Submit */}
                        <>
                          Submit
                          {isSubmit && (
                            <>
                              {" "}
                              <span className="button-loader-cls"></span>{" "}
                            </>
                          )}
                        </>
                      </button>
                    </div>
                  </>
                )}
              </form>
            </div>
          )}
        </section>
        <ToastContainer />
      </div>
      <PatientFooter />
    </>
  );
}
